import store from '../../init/store.js'
import {sendBattleStateToServer} from './firebase'
import {getInitialBattleState} from '../lifecycle/init-battle.js'

//import {buildTeamsFromCombatantData} from '../lifecycle/build-teams-from-combatant-data.js'
import {buildTeamsEvenly} from '../lifecycle/build-teams-evenly'
import {buildTeamsFromClientBuddies} from '../lifecycle/build-teams-from-client-buddies'
import {applyArenaPositionsForOpenBattle} from './applyArenaPositionsForOpenBattle'



export function masterChecksForAllClientsReady() {
  if (store.getState().battle.isMultiplayerMasterClient) {

    //Get connected keys that are clients.
    const clientKeys = Object.keys(
      store.getState().matchmaking.initialCombatantData
    ).filter(key => key.match(/^client_/)).map(key => key.replace("client_", ""));

    //Check that we have readies for each of the clients.
    const readyClients = store.getState().matchmaking.readyClients;
    const allClientsReady = clientKeys.every(key => readyClients[key]);

    //If all clients are contained in the ready object, and we're not the only client.
    const roomType = store.getState().matchmaking.currentRoomType;
    if (allClientsReady && roomType === "fullteam" && clientKeys.length > 1) {
      masterStartBattle();
    }
    if (allClientsReady && roomType === "open") {
      masterStartBattle();
    }

  }

  //Make sure that the combatant's were checking are the actual connections. Stale "readys" may be here
  //from people leaving.

}


/** ONLINE ONLY - Master sends out notification of battle starting */
export async function masterStartBattle() {

  //Must be the Master and have the battle NOT be started
  if (store.getState().battle.isMultiplayerMasterClient && !store.getState().battle.hasBattleStarted) {

    const snapshot = await window.roomRef.child("initialCombatantData").once("value");
    let initialCombatantDataFromServer = {...snapshot.val()};

    //Use combatant data to build teams (sides and items)
    //const teams = buildTeamsFromCombatantData(initialCombatantDataFromServer);
    //TODO: ^^ This func will for sure be needed for single player game experience.. uses `wantsToJoinTeam`.


    const roomType = store.getState().matchmaking.currentRoomType;
    const teams = (roomType === "fullteam")
      ? buildTeamsFromClientBuddies(initialCombatantDataFromServer)
      : buildTeamsEvenly(initialCombatantDataFromServer);


    //OPEN BATTLES: Auto apply arenaPositions
    if (roomType === "open") {
      //Replace combatant structure with newly baked arenaPositions.
      initialCombatantDataFromServer = applyArenaPositionsForOpenBattle(initialCombatantDataFromServer, teams);
    }


    //Seed the bots
    //Lets set the bots here!
    const initialCombatantData = store.getState().matchmaking.initialCombatantData;
    let initialBots = {};
    Object.keys(initialCombatantData).forEach(id => {
      const model = initialCombatantData[id];
      if (model.isBot) {
        initialBots[id] = {
          combatantName: model.name //TODO: This value isn't used or do anything. It just holds space
        }
      }
    });

    window.roomRef.child('bots').set(initialBots).then( () => {

      //console.log('+++++++', initialBots, "set")

      //Start the battle
      window.roomRef.child('hasBattleStarted').set(true);

      //Set up the very first pass for rejoiners
      //Note: the only people who "request" this property are people who are rejoining
        // -> Master resets this property on every "seen" he sends, but that doesnt happen til after the first turn. So set the initial value here.
      window.roomRef.child('rejoinCombatantState').set(initialCombatantData);
      window.roomRef.child('rejoinTeams').set(teams);


      //Send out the first state
      sendBattleStateToServer(getInitialBattleState(initialCombatantDataFromServer, teams));


    });
  }

}


// WEBPACK FOOTER //
// ./src/battle/connection/firebase-start-battle.js